export default __webpack_public_path__ + "static/media/memory.894e535c.jpg";